import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATHS } from '../../routes/Routes';
import { useGetCurrentUserSettings } from '../../services/react-query/users/useGetCurrentUserSettings';
import { EventViewSetting } from '../../types/User';
import { Loading } from '../../uikit';

const EventsRedirect: React.FC = () => {
  const navigate = useNavigate();
  const { data, isLoading } = useGetCurrentUserSettings();

  useEffect(() => {
    if (isLoading) return;

    const view = data?.settings?.event_view ?? EventViewSetting.TABLE;

    switch (view) {
      case EventViewSetting.CALENDAR:
        navigate(`/${ROUTE_PATHS.EVENTS_CALENDAR}`, { replace: true });
        break;
      case EventViewSetting.MAP:
        navigate(`/${ROUTE_PATHS.EVENTS_MAP}`, { replace: true });
        break;
      default:
        navigate(`/${ROUTE_PATHS.EVENTS_TABLE}`, { replace: true });
    }
  }, [data, isLoading, navigate]);

  if (isLoading) {
    return <Loading />;
  }

  return null;
};

export default EventsRedirect;
